<template>
  <b-modal
    v-model="isVisible"
    centered
    hide-header
    hide-header-close
    hide-footer
    content-class="!rounded-[12px]"
    body-class="!p-[1.5rem]"
    @hidden="onHidden"
  >
    <h4 class="!text-[18px] font-medium mb-[0.75rem] text-[#0A0A0A]">
      Hapus Artikel?
    </h4>
    <p
      v-if="item.count > 1"
      class="mb-[1.75rem] text-[14px] text-[#737373]"
    >
      Hapus {{ item.count }} Artikel? Anda yakin ingin menghapus {{ item.count }} artikel terpilih secara permanen? Tindakan ini tidak dapat dibatalkan.
    </p>
    <p
      v-else
      class="mb-[1.75rem] text-[14px] text-[#737373] break-words"
    >
      Yakin ingin menghapus artikel <strong class="text-[#0A0A0A]">{{ item.title }}</strong> secara permanen? Artikel ini tidak akan bisa diakses lagi oleh pengguna maupun agen.
    </p>

    <div class="flex justify-end items-center mt-[1.25rem] gap-[0.5rem]">
      <b-button
        variant="ghost"
        size="sm"
        class="!text-[#737373] !font-normal !px-[1rem] !border-[1px] !border-[#E5E5E5] !py-[0.65rem] !shadow-[0px_1px_2px_0px_#0000001A] !rounded-[8px]"
        :disabled="isLoading"
        @click="close"
      >
        Batal
      </b-button>
      <b-button
        variant="primary"
        class="!rounded-[8px] !px-[1rem] !py-[0.65rem] !flex items-center justify-center gap-[8px]"
        size="sm"
        :disabled="isLoading"
        @click="submit"
      >
        <b-spinner
          v-if="isLoading"
          small
        />
        <span>Hapus</span>
      </b-button>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'ArticleDeleteDialog',
  data() {
    return {
      isVisible: false,
      isLoading: false,
      onSubmitCallback: null,
      onCloseCallback: null,

      item: {
        judul: '',
      },
    }
  },
  methods: {
    /**
     * Opens the delete confirmation dialog.
     * @param {Object} options
     * @param {{ id: number, title: string }} options.item - The article to be deleted
     * @param {Function} [options.onSubmit] - Async callback called on confirm; receives `item` as argument
     * @param {Function} [options.onCancel] - Callback called when the dialog is cancelled
     */
    show(options = {}) {
      this.onSubmitCallback = options.onSubmit || null
      this.onCloseCallback = options.onCancel || null
      this.isVisible = true

      this.item = options.item || {
        title: '',
      }
    },
    /** Resets the item data after the modal's hide animation completes */
    onHidden() {
      this.$emit('close')
      this.item = {
        title: '',
      }
    },
    /** Closes the modal and invokes onCloseCallback if one was provided */
    close() {
      this.isVisible = false
      if (typeof this.onCloseCallback === 'function') this.onCloseCallback()
    },
    /**
     * Executes the onSubmitCallback and then closes the modal.
     * Falls back to just closing if no callback was provided.
     */
    async submit() {
      if (typeof this.onSubmitCallback === 'function') {
        try {
          this.isLoading = true
          await this.onSubmitCallback(this.item)
          this.close()
        } finally {
          this.isLoading = false
        }
      } else {
        this.close()
      }
    },
  },
}
</script>
